"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.connectAvatar = exports.default = void 0;

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _connectToWebChat = _interopRequireDefault(require("../connectToWebChat"));

var _CroppedImage = _interopRequireDefault(require("../Utils/CroppedImage"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var connectAvatar = function connectAvatar() {
  for (var _len = arguments.length, selectors = new Array(_len), _key = 0; _key < _len; _key++) {
    selectors[_key] = arguments[_key];
  }

  return _connectToWebChat.default.apply(void 0, [function (_ref, _ref2) {
    var _ref$styleSet$options = _ref.styleSet.options,
        botAvatarImage = _ref$styleSet$options.botAvatarImage,
        botAvatarInitials = _ref$styleSet$options.botAvatarInitials,
        userAvatarImage = _ref$styleSet$options.userAvatarImage,
        userAvatarInitials = _ref$styleSet$options.userAvatarInitials;
    var fromUser = _ref2.fromUser;
    return {
      avatarImage: fromUser ? userAvatarImage : botAvatarImage,
      avatarInitials: fromUser ? userAvatarInitials : botAvatarInitials
    };
  }].concat(selectors));
}; // TODO: [P2] Consider memoizing "style={ backgroundImage }" in our upstreamers
//       We have 2 different upstreamers <CarouselFilmStrip> and <StackedLayout>


exports.connectAvatar = connectAvatar;

var Avatar = function Avatar(_ref3) {
  var ariaHidden = _ref3['aria-hidden'],
      avatarImage = _ref3.avatarImage,
      avatarInitials = _ref3.avatarInitials,
      className = _ref3.className,
      fromUser = _ref3.fromUser,
      styleSet = _ref3.styleSet;
  return !!(avatarImage || avatarInitials) && _react.default.createElement("div", {
    "aria-hidden": ariaHidden,
    className: (0, _classnames.default)(styleSet.avatar + '', {
      'from-user': fromUser
    }, className + '')
  }, avatarInitials, !!avatarImage && _react.default.createElement(_CroppedImage.default, {
    alt: "",
    className: "image",
    height: "100%",
    src: avatarImage,
    width: "100%"
  }));
};

Avatar.defaultProps = {
  'aria-hidden': false,
  avatarImage: '',
  avatarInitials: '',
  className: '',
  fromUser: false
};
Avatar.propTypes = {
  'aria-hidden': _propTypes.default.bool,
  avatarImage: _propTypes.default.string,
  avatarInitials: _propTypes.default.string,
  className: _propTypes.default.string,
  fromUser: _propTypes.default.bool,
  styleSet: _propTypes.default.shape({
    avatar: _propTypes.default.any.isRequired
  }).isRequired
};

var _default = connectAvatar(function (_ref4) {
  var styleSet = _ref4.styleSet;
  return {
    styleSet: styleSet
  };
})(Avatar);

exports.default = _default;